import { useMemo, useRef } from 'react';
import { useBundleStore } from '../hooks/bundle-store';
import { useShallow } from 'zustand/react/shallow';
import Camera from './camera';
import FlooringModel from './flooring-model';
import ModelItem from './model';

interface ModelListProps {
  canvasParent: HTMLElement | null;
  cameraControlRef: any;
  modelsRef: any;
}

export default function ModelList({ canvasParent, cameraControlRef, modelsRef }: ModelListProps) {
  const { bundle, isFloorPlanModelExist, printedSideSpecData, enableZoom, isApparel } =
    useBundleStore(
      useShallow((state) => ({
        bundle: state?.bundle,
        isFloorPlanModelExist: state?.bundle?.isFloorPlanModelExist,
        printedSideSpecData: state?.printedSideSpecData,
        enableZoom: state?.enableZoom,
        isApparel: state?.bundle?.isApparel,
      })),
    );

  const isSingle = bundle?.isSingle;

  const models = useMemo(() => {
    return bundle?.models?.filter((model) => model?.code !== 'WITHOUT_SECTION' && !!model?.src);
  }, [bundle?.models]);

  return (
    models && (
      <>
        <Camera
          canvasParent={canvasParent}
          cameraControlRef={cameraControlRef}
          modelsRef={modelsRef}
          enableZoom={enableZoom}
        />
        <group name="models" ref={modelsRef}>
          {!isFloorPlanModelExist && !isSingle && !isApparel && (
            <FlooringModel
              width={bundle?.floorWidth as number}
              length={bundle?.floorLength as number}
            />
          )}
          {models?.map((model) => {
            return (
              <ModelItem model={model} key={model?.id} printedSideSpecData={printedSideSpecData} />
            );
          })}
        </group>
      </>
    )
  );
}
